import { Button, Input, Textarea, toast } from "@/components/kit";
import {
  FieldContent,
  FieldLabel,
  Field as FieldLayout,
} from "@/components/ui/field";
import { useActionPermission } from "@/modules/auth/presentation/model/useActionPermission";
import { DEFAULT_ORDER_SUMMARY_TEMPLATE } from "@/modules/chat-tools/domain/default-template";
import { useEffect, useState } from "react";
import {
  useShopSettingsQuery,
  useUpdateShopSettings,
} from "@/modules/chat-tools/presentation/api/queries";

export function ShopSettingsSection() {
  const canManage = useActionPermission(
    ["settings:write", "orders:write"],
    "any",
  );
  const query = useShopSettingsQuery();
  const update = useUpdateShopSettings();

  const [shopDisplayName, setShopDisplayName] = useState("");
  const [shopPhone, setShopPhone] = useState("");
  const [bankName, setBankName] = useState("");
  const [bankAccountNumber, setBankAccountNumber] = useState("");
  const [bankAccountName, setBankAccountName] = useState("");
  const [orderSummaryTemplate, setOrderSummaryTemplate] = useState(
    DEFAULT_ORDER_SUMMARY_TEMPLATE,
  );

  useEffect(() => {
    if (!query.data) return;
    setShopDisplayName(query.data.shopDisplayName);
    setShopPhone(query.data.shopPhone);
    setBankName(query.data.bankName);
    setBankAccountNumber(query.data.bankAccountNumber);
    setBankAccountName(query.data.bankAccountName);
    setOrderSummaryTemplate(query.data.orderSummaryTemplate);
  }, [query.data]);

  function handleSave() {
    update.mutate(
      {
        shopDisplayName: shopDisplayName.trim(),
        shopPhone: shopPhone.trim(),
        bankName: bankName.trim(),
        bankAccountNumber: bankAccountNumber.trim(),
        bankAccountName: bankAccountName.trim(),
        orderSummaryTemplate,
      },
      {
        onSuccess: () => toast.success("ບັນທຶກການຕັ້ງຄ່າຮ້ານແລ້ວ"),
        onError: (e) =>
          toast.error("ບັນທຶກບໍ່ສຳເລັດ", {
            description: e instanceof Error ? e.message : undefined,
          }),
      },
    );
  }

  if (query.isLoading) {
    return <p className="text-muted-foreground text-sm">ກຳລັງໂຫຼດ...</p>;
  }

  return (
    <div className="flex max-w-2xl flex-col gap-6">
      <div>
        <h3 className="font-display text-lg">ການຕັ້ງຄ່າຮ້ານ & ແຊດ</h3>
        <p className="text-muted-foreground text-sm">
          ເລກບັນຊີ ແລະ template ສະຫຼຸບອໍເດີ້ສຳລັບ Copy ໃນ Facebook
        </p>
      </div>

      <FieldLayout>
        <FieldLabel>ຊື່ຮ້ານ (ໃນ template)</FieldLabel>
        <FieldContent>
          <Input
            value={shopDisplayName}
            onChange={(e) => setShopDisplayName(e.target.value)}
            disabled={!canManage}
          />
        </FieldContent>
      </FieldLayout>

      <FieldLayout>
        <FieldLabel>ເບີໂທຜູ້ຝາກ (ປ້າຍສົ່ງ)</FieldLabel>
        <FieldContent>
          <Input
            value={shopPhone}
            onChange={(e) => setShopPhone(e.target.value)}
            placeholder="9661 9695"
            disabled={!canManage}
          />
        </FieldContent>
      </FieldLayout>

      <div className="grid gap-4 sm:grid-cols-2">
        <FieldLayout>
          <FieldLabel>ທະນາຄານ</FieldLabel>
          <FieldContent>
            <Input
              value={bankName}
              onChange={(e) => setBankName(e.target.value)}
              placeholder="ກະສິກ"
              disabled={!canManage}
            />
          </FieldContent>
        </FieldLayout>
        <FieldLayout>
          <FieldLabel>ເລກບັນຊີ</FieldLabel>
          <FieldContent>
            <Input
              value={bankAccountNumber}
              onChange={(e) => setBankAccountNumber(e.target.value)}
              disabled={!canManage}
            />
          </FieldContent>
        </FieldLayout>
      </div>

      <FieldLayout>
        <FieldLabel>ຊື່ບັນຊີ</FieldLabel>
        <FieldContent>
          <Input
            value={bankAccountName}
            onChange={(e) => setBankAccountName(e.target.value)}
            disabled={!canManage}
          />
        </FieldContent>
      </FieldLayout>

      <FieldLayout>
        <FieldLabel>Template ສະຫຼຸບອໍເດີ້</FieldLabel>
        <FieldContent>
          <Textarea
            value={orderSummaryTemplate}
            onChange={(e) => setOrderSummaryTemplate(e.target.value)}
            rows={12}
            className="font-mono text-sm"
            disabled={!canManage}
          />
        </FieldContent>
        <p className="mt-2 text-muted-foreground text-xs">
          ຕົວແປ: {`{{order_number}}`}, {`{{lines}}`}, {`{{total}}`},
          {`{{bank_block}}`}, {`{{customer_line}}`}, ...
        </p>
      </FieldLayout>

      {canManage ? (
        <Button
          className="rounded-full"
          isLoading={update.isPending}
          onClick={handleSave}
        >
          ບັນທຶກການຕັ້ງຄ່າຮ້ານ
        </Button>
      ) : null}
    </div>
  );
}
